import React from "react";
import AccountFormPage from "./AccountFormPage";

function AccountEditPage() {
  return <AccountFormPage mode="edit" />;
}

export default AccountEditPage;
